module.exports = __webpack_public_path__ + "img/liucheng_sy.bd9a5a91.png";